import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { useNavigation } from '@react-navigation/native';

const Header = ({headerText = 'LOGO', drawerIconVisible =true, userBalance='--', balfetching}) => {
  const navigation = useNavigation();
  
  return (
    <View style={styles.headerContainer}>
      {
        headerText = 'LOGO' ? <Image source={require('../../assets/appLogo.png')} style={{width:150, height:60}} resizeMode='contain'/>:
        <Text style={styles.logoText}>{headerText}</Text>
      }
     {drawerIconVisible && (
      <View style={{flexDirection:'row',justifyContent:'center',alignItems:'center',gap:15}}>
     <View style={{width:70,backgroundColor:'#f7ec79',justifyContent:'center',alignItems:'center',height:40,flexDirection:'row',gap:5,padding:5}}>
     <Image source={require('../../assets/Coin.png')} style={{width:30, height:30}} />
      <Text style={{fontSize:22,fontWeight:'500'}}>
        {userBalance}
      </Text>

     </View>
      <TouchableOpacity onPress={() => navigation.openDrawer()}>
        <Ionicons name="menu" size={25} color="#000" />
      </TouchableOpacity>
      </View>
    
    )}
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#f0df21',
    padding: 10,
    height: 60,
    width:'100%',
    alignItems:'center'
  },
  logoText: {
    fontSize: 24,
    fontWeight: '500',
    color: '#000',
  },

});

export default Header;
